import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { memo as p, useMemo as s } from "react";
import { SemanticType as l } from "../MetaModel.js";
import { TooltipContainer as m, TooltipAlias as a, TooltipContentElement as T, TooltipText as d, MdView as u, concatInformationLinkToText as h } from "@biron-data/react-components";
import { useLanguageResolver as x } from "@biron-data/react-contexts";
import { c as f, n as y } from "../index-a388f2ac-Cf1pu7LW.js";
const A = p(({ dimension: t, getMoreInformationLink: e }) => {
  const c = x(), i = e == null ? void 0 : e(t.code), n = s(() => {
    switch (t.semanticType) {
      case l.NUMBER:
        return y;
      default:
        return f;
    }
  }, [t.semanticType]);
  return /* @__PURE__ */ r(m, { children: [
    /* @__PURE__ */ r(a, { translate: "no", children: [
      /* @__PURE__ */ o(n, {}),
      t.alias
    ] }),
    /* @__PURE__ */ o(T, { children: /* @__PURE__ */ o(d, { children: /* @__PURE__ */ o(u, { description: h(t.description, c, i), padding: 0 }) }) })
  ] });
});
export {
  A as TooltipContentDimension
};
//# sourceMappingURL=TooltipContent.Dimension.js.map
